import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MessageDialogComponent } from '../message-dialog/message-dialog.component';
import { MatDialogRef } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})
export class MessageDialogService {

  constructor(private dialog: MatDialog) {}

  open(message: string, title: string = null): MatDialogRef<MessageDialogComponent> {
    return this.dialog.open(MessageDialogComponent, {
      data: { message, title }
    });
  }
}
